import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { KartexPreset } from './app/layout/kartex-preset';
import { orgTokenInterceptor } from './app/org/auth/org-token.interceptor';
import { tokenInterceptor } from './app/service/auth.interceptor';
import { paymentRequiredInterceptor } from './app/service/payment-required.interceptor';
import { cardV2HttpInterceptor } from './app/service/card-v2-http.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpInterceptorFn } from '@angular/common/http';

/** Sıra önemlidir: orgTokenInterceptor ilk olmalı (org istekleri zincirin geri kalanına girmez). */
export const APP_INTERCEPTORS: HttpInterceptorFn[] = [orgTokenInterceptor, tokenInterceptor, cardV2HttpInterceptor, paymentRequiredInterceptor];

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    const cacheBuster = new Date().getTime();
    return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${cacheBuster}`);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation(), withComponentInputBinding()),
        provideHttpClient(withFetch(), withInterceptors(APP_INTERCEPTORS)),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: KartexPreset, options: { darkModeSelector: '.app-dark' } } }),
        ...(TranslateModule.forRoot({
            defaultLanguage: 'tr',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }).providers || [])
    ]
};
